import _ from 'lodash';

const { Order } = Mobi2Go;
// TODO: implement whatever kind of filter you want
export default products =>
    _.filter(products, product => !Order.isProductHidden(product));
